import React, { useState } from "react";

// Lets the user pick a policy slug to append to a bundle. Kept deliberately
// small for the MVP — a fuller picker (registers, risks, freeform) can grow
// from this seam post-carve-out.
export default function BundleItemPicker({ policies, onAdd }) {
  const [slug, setSlug] = useState("");

  const add = () => {
    if (!slug) return;
    const policy = policies.find((p) => p.slug === slug);
    onAdd({ kind: "policy", ref_id: slug, title: policy ? policy.title : slug });
    setSlug("");
  };

  return (
    <div className="flex items-center gap-2" data-testid="bundle-item-picker">
      <select
        className="rounded border border-slate-300 px-2 py-1 text-sm"
        value={slug}
        onChange={(e) => setSlug(e.target.value)}
        data-testid="bundle-item-select"
      >
        <option value="">Add a policy…</option>
        {policies.map((p) => (
          <option key={p.slug} value={p.slug}>
            {p.title}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={add}
        disabled={!slug}
        className="rounded bg-indigo-600 px-3 py-1 text-sm text-white disabled:opacity-40"
        data-testid="bundle-item-add"
      >
        Add
      </button>
    </div>
  );
}
